import { useAuth } from "../hooks/useAuth";
import { HomePage } from "./HomePage";
import { MarketingPage } from "./site/MarketingPages";
import { usePublicConfig } from "./site/SiteLayout";

/** A join cookie is enough to preserve the name/PIN picker before a crew token exists. */
export function RootPage() {
  const { player, isOwner, loading, orgId } = useAuth();
  const { data: config, isPending } = usePublicConfig();
  if (loading || (isPending && !player && !isOwner && orgId === null)) return <div className="site-boot" role="status">Opening Trim Log…</div>;
  if (player || isOwner || (!config && orgId !== null) || config?.workspace_joined) return <HomePage />;
  return <MarketingPage />;
}
